export default __webpack_public_path__ + "static/media/L9qn7Ho.3ae00245.png";